import * as React from "react";
import { RadioGroup } from "../../../react-core/Html/RadioGroup";
import { OrderType } from "../../../Wrap/Constants/Enums/Domain/OrderType";

interface IQuantitySwitchProps {
    type: OrderType;
    onChange: (v: OrderType) => void;
    hasModel: boolean;
}

export const QuantitySwitch = (props: IQuantitySwitchProps) => {
    const type = props.type || OrderType.Percentage;

    const orderTypeMap = {
        [OrderType.Percentage]: "%",
        [OrderType.Value]: "£",
        [OrderType.Quantity]: "Units",
    };

    let options = [OrderType.Percentage, OrderType.Value, OrderType.Quantity];
    if (props.hasModel) {
        options = options.filter((ele) => ele !== OrderType.Quantity);
    }

    return (
        <RadioGroup
            cssWrapper="value-type inline-block mt-10"
            options={options}
            getText={(o) => orderTypeMap[o]}
            label="Value type"
            onChange={(v) => props.onChange(v)}
            selected={type}
            radioLabelCss="radio-button pin-radio"
        />
    );
};
